import React from 'react';

export const WheelArrow = () => {
  return (
    <div className='mob-game-arr-ins'>
      <div className='mob-top-arr-it2'>
        <span className='mob-top-arr-it2-sp' />
      </div>
      <div className='mob-top-arr-it top3' />
    </div>
  );
};
